import { baseService } from './baseService'

export default {
    loggedUser
};

function loggedUser() {
    console.log("Onlogged")
    return baseService.get('api/user/loggedUser');
}